import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setupPinia } from '@/store/pinia.js'
import i18n from './i18n'
import axios from './plugins/axios'
import apis from './api'
import directives from './directives'
import JLTools from '@/util/JLTools'
import mitt from 'mitt'
import Modal from '@/components/Modal/modal'
import Toast from '@/components/Toast/toast'
import message from '@/components/Message'
import JLImg from '@/components/JLImg'
import imgUpload from '@/components/uploadImg'
import hypertext from '@/components/hypertext'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/fonts/font.css'
import '@/assets/icon/iconfont.css'
// 导入样式文件
import '@/assets/css/index.less'
import { switchTheme, initTheme } from '@/config/theme.js'
// 引入心跳插件
// import HeartbeatPlugin from '@/plugins/heartbeat' // 引入插件

//进入新页面回到浏览器顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

const app = createApp(App)
  .use(i18n)
  .use(axios)
  .use(apis)
  .use(directives)
  .use(router)
  .use(JLTools)
  .use(Toast)
  .use(message)
  .use(Modal)
  .use(ElementPlus)
// .use(HeartbeatPlugin) // 安装心跳插件

app.use(setupPinia(app))

app.component('JLImg', JLImg)
app.component('img-upload', imgUpload)
app.component('hypertext', hypertext)

app.config.globalProperties.$mybus = new mitt()

app.mount('#app')


import('@/util/trackGA').then((m) => {
  const trackGA = m.default
  app.config.globalProperties.$trackGA = trackGA
  window.trackGA = trackGA // 你说的全局变量
  if (window.__NUXT_GA_DEBUG__ === true && typeof m.syncGa4DebugUserProperties === 'function') {
    m.syncGa4DebugUserProperties()
  }
})

export default app
